<!---- Static Navbar start -->
<div class="header-bar">
  <div class="navbar navbar-custom">
    <a class="navbar-brand logomain mt-2" id="hidetxt"
      ><img
        src="assets/images/logotxt.svg"
        height="33"
        class="logo ml-3 logotextClick" /><img
        src="assets/images/logotxt.svg"
        width="150"
        class="logo1 sectpad logotextClick"
    /></a>
  </div>
  <div class="col-12 text-center webview">
    <!-- <img src="assets/images/eva-icons.svg" class="signimg1 prescsimg" /> -->
  </div>
</div>
<!---- Static Navbar end -->
<main role="main" class="maincntq">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
        <div class="col-sm-12 p-0 mt-5">
          <h1 class="text-center ssnHeadTxt">
            It looks like you may have placed <br />
            a freeze on your SSN
          </h1>
          <div class="col-lg-4 col-md-6 m-auto" id="headdiv">
            <span class="ssnTxt d-inline-block mt-3">
              Please click the button below and follow the instructions provided
              by the credit bureau to unfreeze your credit.
            </span>
            <span class="ssnTxt d-inline-block mt-3">
              Be sure to come back here when you’re done so that we can
              re-process your enrollment.
            </span>
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
            <button
              class="btn sectbtn mt-5 creditClass"
              (click)="gotoUnfreezemyCredit()"
            >
              UNFREEZE MY CREDIT
            </button>
            <!-- </div>
          <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center"> -->
            <button
              class="btn btn-gray mt-5"
              style="
                width: 235px !important;
                padding-left: 25px;
                font-size: 18px;
                padding-right: 25px;
              "
              (click)="gotoHome()"
            >
              NO,THANK YOU
            </button>
          </div>
        </div>
        <div class="col-sm-12 p-0 text-center">
          <div class="m-auto col-sm-10 col-md-6 col-xl-3 blockbg prebox">
            <img src="assets/images/flash.png" class="mb-1" />
            <p class="text-center pretipwgt">TIP OF THE DAY</p>
            <p class="text-center linhgtnor tipmes">
              Unless you are planning to sign up for PrePaid energy, all energy
              providers require a credit check to be performed to establish
              service.
            </p>
          </div>
        </div>
      </div>
      <div class="row-fluid mobileview mt-0 pt-4">
        <div class="d-flex h-100 row pr-0">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img
              style="width: 100% !important"
              src="assets/images/signimg.jpg"
            />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box mr-3" [@flyOut]="'in'">
              <h1 class="questionMob text-left">
                We were unsuccessful in processing your enrollment. It appears
                that you may have placed a credit freeze on your SSN.
              </h1>
            </div>
          </div>
        </div>
        <div class="d-flex h-100 row pr-0 mt-3 mb-2" *ngIf="showDiv == true">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img
              style="width: 100% !important"
              src="assets/images/signimg.jpg"
            />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto" id="fisrtDiv">
            <div class="arrow_box mr-3" [@flyOut]="'in'">
              <h1 class="questionMob text-left">
                Would you like for me to show you how to unfreeze your credit?
              </h1>
            </div>
          </div>
        </div>

        <div class="d-flex h-100 row pr-0">
          <div
            class="col-sm-9 col-11 offset-col-1 px-0 m-auto"
            *ngIf="showDiv == true"
          >
            <div class="col-12 px-0 mobileview">
              <label
                class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                for="yes"
              >
                <input
                  type="checkbox"
                  class="custom-control-input mgntp10"
                  id="yes"
                  value="Yes"
                  name="yes"
                  [(ngModel)]="servicedeniedList.value1"
                  (click)="onChangeRole($event)"
                />
                <label class="custom-control-label font16" for="yes">Yes</label>
              </label>
              <label
                class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                for="nothankyou"
              >
                <input
                  type="checkbox"
                  class="custom-control-input mgntp10"
                  id="nothankyou"
                  value="No, thank you"
                  name="nothankyou"
                  [(ngModel)]="servicedeniedList.value2"
                  (click)="onChangeRole($event)"
                />
                <label class="custom-control-label font16" for="nothankyou"
                  >No, thank you</label
                >
              </label>
            </div>
          </div>
        </div>

        <div class="col-sm-9 col-12 ml-auto px-0" id="addf_id">
          <div
            class="col-12 px-0"
            style="width: 100% !important; text-align: right"
          >
            <div
              class="mb-3 ash_box text-right"
              [@flyOutans]="'in'"
              *ngIf="isChecked && ansinSSncheck == 'Goodbye'"
            >
              <h1 class="inline-block ansMob text-right" *ngIf="isChecked">
                {{ ansinSSncheck }}
              </h1>
            </div>
          </div>
        </div>

        <div id="thankAns">
          <div
            class="d-flex h-100 row pr-0"
            *ngIf="
              isChecked &&
              ansinSSncheck ==
                'Yes, I remember placing something on my credit report to prevent fraud.' &&
              timeTrue == true
            "
          >
            <div class="col-sm-9 col-12 ml-auto px-0" id="addf_id">
              <div
                class="col-12"
                style="width: 100% !important; text-align: right"
              >
                <div
                  class="mb-3 ash_box text-right"
                  [@flyOutans]="'in'"
                  *ngIf="isChecked && ansinSSncheck"
                >
                  <h1 class="inline-block ansMob text-right" *ngIf="isChecked">
                    {{ ansinSSncheck }}
                  </h1>
                </div>
              </div>
            </div>
            <div class="d-flex h-100 row px-3" *ngIf="GreatDiv == true">
              <div
                class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
              >
                <img
                  style="width: 100% !important"
                  src="assets/images/signimg.jpg"
                />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                <div class="arrow_box mr-3" [@flyOut]="'in'">
                  <h1 class="questionMob text-left">
                    Great, when you tap the button below, you will be directed
                    to the credit bureau that has a freeze on your account.
                  </h1>
                </div>
              </div>
            </div>
            <div
              class="d-flex h-100 row px-3 mt-3 mb-2"
              *ngIf="GreatDiv == true"
            >
              <div
                class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
              >
                <img
                  style="width: 100% !important"
                  src="assets/images/signimg.jpg"
                />
              </div>
              <div class="col-sm-9 col-9 px-0 my-auto">
                <div class="arrow_box mr-3" [@flyOut]="'in'">
                  <h1 class="questionMob text-left">
                    Be sure to come back here when you’re done so that we can
                    re-process your enrollment.
                  </h1>
                </div>
              </div>
            </div>
            <div class="text-right w-100 mr-3 ml-3" *ngIf="GreatDiv == true">
              <div
                class="text-center pull-right col-sm-9 col-12 p-2 pr-0 mr-0 mt-3 box-shadow"
              >
                <label
                  class="font16 px-0 mt-2 mb-1"
                  (click)="gotoUnfreezemyCredit()"
                >
                  Take me to Experian to unfreeze</label
                >
              </div>
            </div>

            <div class="col-sm-9 col-9 ml-auto mt-3 px-0">
              <div
                class="col-12"
                style="width: 100% !important; text-align: right"
              >
                <div
                  id="secondAns_id"
                  class="mb-2 ash_box text-right"
                  [@flyOutans]="'in'"
                  *ngIf="ansinSSncheck1 == 'Goodbye'"
                >
                  <h1 class="ansMob text-right">{{ ansinSSncheck1 }}</h1>
                </div>
              </div>
            </div>

            <div class="col-sm-9 col-9 ml-auto mt-1 px-0">
              <div
                class="col-12"
                style="width: 100% !important; text-align: right"
              >
                <div
                  id="secondAns_id2"
                  class="mb-3 ash_box text-right"
                  [@flyOutans]="'in'"
                  *ngIf="ansinSSncheck2"
                >
                  <h1 class="ansMob text-right">{{ ansinSSncheck2 }}</h1>
                </div>
              </div>
            </div>

            <div class="col-sm-9 col-9 ml-auto mt-1 px-0">
              <div
                class="col-12"
                style="width: 100% !important; text-align: right"
              >
                <div
                  id="secondAns_id3"
                  class="mb-3 ash_box text-right"
                  [@flyOutans]="'in'"
                  *ngIf="ansinSSncheck3"
                >
                  <h1 class="ansMob text-right">{{ ansinSSncheck3 }}</h1>
                </div>
              </div>
            </div>

            <div id="ansinSSncheck3div">
              <div
                class="d-flex row px-3 mt-3"
                *ngIf="
                  isChecked &&
                  ansinSSncheck3 == 'Okay, I’m back!' &&
                  timeTrue == true
                "
              >
                <div
                  class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
                >
                  <img
                    style="width: 100% !important"
                    src="assets/images/signimg.jpg"
                  />
                </div>
                <div class="col-sm-9 col-9 px-0 my-auto">
                  <div
                    class="arrow_box mr-3"
                    *ngIf="isChecked && ansinSSncheck3 == 'Okay, I’m back!'"
                  >
                    <h1 class="questionMob text-left">
                      Sweet! For security purposes, we have saved your responses
                      and logged you out. Please log back in using the same
                      method as before to continue.
                    </h1>

                    <!-- <h1 class="questionMob">
                      Sweet! Hope you successfully managed your credit proﬁle.
                      To ﬁnalize your enrollment (or to ask any questions),
                      please contact
                      <span class="font-weight-bold p-1">{{
                        selectedProduct.energy_provider
                      }}</span>
                      <span class="mb-1"
                        >{{
                          providerContact != undefined &&
                          providerContact.working_hours
                            ? providerContact.working_hours
                            : ''
                        }} </span
                      ><br />
                      <span class="clrblue"
                        ><a
                          [href]="
                            'tel:' + providerContact.customerDeposit_enquiry
                          "
                          style="cursor: pointer !important"
                          >{{
                            providerContact != undefined &&
                            providerContact.customerDeposit_enquiry
                              ? providerContact.customerDeposit_enquiry
                              : ''
                          }}</a
                        ></span
                      >
                      <span>
                        to re-run your credit and process your request to sign
                        up. If after hours, please leave a message and someone
                        will call you back.</span
                      >
                    </h1> -->
                  </div>
                </div>
              </div>

              <div
                class="d-flex row px-3 mt-3"
                *ngIf="
                  isChecked &&
                  ansinSSncheck3 == 'Okay, I’m back!' &&
                  timeTrue == true &&
                  besureDiv == true
                "
              >
                <div
                  class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
                >
                  <img
                    style="width: 100% !important"
                    src="assets/images/signimg.jpg"
                  />
                </div>
                <div class="col-sm-9 col-9 px-0 my-auto">
                  <div
                    class="arrow_box mr-3"
                    *ngIf="isChecked && ansinSSncheck3 == 'Okay, I’m back!'"
                  >
                    <h1 class="questionMob text-left">
                      Just a heads up, you will be asked to verify some info
                    </h1>
                  </div>
                </div>
                <div
                  class="col-sm-12 m-auto text-left mr-4"
                  style="width: 95% !important"
                >
                  <!-- <div class="col-sm-12 p-0 signupmobile"> -->
                  <a
                    _ngcontent-c5=""
                    class="mobclose"
                    href="javascript:void(0);"
                    ><img
                      _ngcontent-c5=""
                      src="assets/images/mobclose.png"
                      (click)="closebtn()"
                  /></a>
                  <!-- <h1 class="text-center headfont loginmrgn signuppadd webview">Login to your account</h1> -->
                  <div
                    class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto my-5 py-3 text-center"
                  >
                    <!-- <a title="Sign up with Facebook" href="{{url}}/auth/facebook" class="btn btn-facebook col-sm-12 p-1 boxcolour sgoptpad mbfbbox"> -->
                    <a
                      title="Sign up with Facebook"
                      href="javascript:void(0);"
                      (click)="getAuthenticate('/auth/facebook')"
                      class="btn btn-facebook pt-1 pb-1 boxcolour sgoptpad minvalue fbNewBtn"
                    >
                      <div class="img-bdr text-center boxcolour">
                        <span class="faceicon">
                          <img
                            src="assets/images/facebook-ronded.svg"
                            width="30"
                          />
                        </span>
                        <span
                          class="pl-2 fntwgtvle sgopt mbtxtbox color-gray font-calibre-regular"
                          >Continue with Facebook</span
                        >
                      </div>
                    </a>
                  </div>

                  <div
                    class="form-group col-lg-7 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center"
                  >
                    <!-- <a title="Sign up with Gmail" href="{{url}}/auth/google" class="btn btn-google p-1 col-sm-12 p-0 boxcolour sgoptpad mbfbbox"> -->
                    <a
                      title="Sign up with Gmail"
                      href="javascript:void(0);"
                      (click)="getAuthenticate('/auth/google')"
                      class="btn btn-google pt-1 pb-1 boxcolour sgoptpad minvalue fbNewBtn"
                    >
                      <div class="img-bdr text-center boxcolour">
                        <span class="googleicon">
                          <img src="assets/images/gmail.svg" width="30" />
                        </span>
                        <span
                          class="pl-2 fntwgtvle sgopt mbtxtbox color-gray font-calibre-regular"
                          >Continue with Google
                        </span>
                      </div>
                    </a>
                  </div>
                  <div
                    class="col-lg-4 col-md-12 col-sm-12 p-0 mb-3 m-auto text-center px-3"
                  >
                    <div class="login-or" style="margin-top: 1.5rem !important">
                      <hr class="hr-or" />
                      <span class="span-or">or</span>
                    </div>
                  </div>
                  <div class="container" style="margin-top: 1rem !important">
                    <div class="row">
                      <div class="text-center pt-3 minvalue m-auto">
                        <!-- <form name="form" (ngSubmit)="f.form.valid && createAccount($event,f);" #f="ngForm" -->
                        <form
                          name="form"
                          (ngSubmit)="createAccount($event, f)"
                          #f="ngForm"
                          novalidate
                        >
                          <div class="text-center minvalue m-auto">
                            <!-- <form role="form" class="" (ngSubmit)="f.form.valid && createAccount($event,f);" #f="ngForm" novalidate> -->
                            <div class="form-group float-label-control">
                              <label for="email">Email/Phone Number</label>
                              <input
                                type="text"
                                class="form-control inputshadow"
                                name="email"
                                [(ngModel)]="userObj.emailId"
                                #email="ngModel"
                                [ngClass]="{
                                  'is-invalid': f.submitted && email.invalid
                                }"
                                required
                                email
                              />
                              <div
                                *ngIf="f.submitted && email.invalid"
                                class="invalid-feedback"
                              >
                                <div
                                  class="posabs font15"
                                  *ngIf="email.errors.required"
                                >
                                  Email/Phone number is required
                                </div>
                              </div>
                            </div>
                            <div class="form-group float-label-control mb-0">
                              <label for="password">Password</label>
                              <input
                                type="password"
                                class="form-control inputshadow"
                                name="password"
                                [(ngModel)]="userObj.password"
                                #password="ngModel"
                                [ngClass]="{
                                  'is-invalid': f.submitted && password.invalid
                                }"
                                required
                              />
                              <div
                                *ngIf="f.submitted && password.invalid"
                                class="invalid-feedback"
                              >
                                <div
                                  class="posabs font15"
                                  *ngIf="password.errors.required"
                                >
                                  Password is required
                                </div>
                              </div>
                            </div>
                            <!-- </form> -->
                          </div>

                          <!-- <div class="form-group col-lg-5 col-md-8 col-sm-4 p-0 mb-3 m-auto text-left pl-2"> -->
                          <div class="text-left minvalue m-auto">
                            <a
                              class="forgbtn font18"
                              href="javascript:void(0)"
                              data-toggle="modal"
                              data-target="#forgotModal"
                              (click)="showForgotModal()"
                            >
                              forgot password?</a
                            >
                          </div>
                          <!-- <a class="btn sectbtn signinpad  mt-4 pl-5 pr-5" href="javascript:void(0)">LOG IN</a> -->
                          <!-- <div class="form-group float-label-control mr-2 ml-2 sectbtn signinpad col-3 mt-5 ressignin"></div> -->
                          <div class="minvalue text-center">
                            <button class="btn sectbtn signinpad mt-4 minvalue">
                              LOGIN
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->
                </div>

                <!-- <div class="text-right w-100 mr-2 mt-3">
                  <div
                    class="text-center pull-right col-sm-9 col-11 p-2 pr-0 mr-2 box-shadow"
                  >
                    <label class="font16 pt-2">
                      <a
                        (click)="clickOnMobile()"
                        [href]="
                          'tel:' + providerContact.customerDeposit_enquiry
                        "
                        >Call now</a
                      >
                      to speak with {{ selectedProduct.energy_provider }}</label
                    >
                  </div>
                </div>

                <div class="col-sm-9 col-9 ml-auto mt-4 px-0">
                  <div
                    class="col-12"
                    style="width: 100% !important; text-align: right"
                  >
                    <div
                      id="secondAns_id3"
                      class="mb-3 ash_box text-right"
                      [@flyOutans]="'in'"
                      *ngIf="ansinSSncheck4"
                    >
                      <h1 class="ansMob text-right">{{ ansinSSncheck4 }}</h1>
                    </div>
                  </div>
                </div>

                <div class="mx-3" id="thankAnsDail">
                  <div
                    class="d-flex row pr-0 mt-2"
                    *ngIf="isChecked && ansinSSncheck4 && timeTrue == true"
                  >
                    <div
                      class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
                    >
                      <img
                        style="width: 100% !important"
                        src="assets/images/signimg.jpg"
                      />
                    </div>
                    <div class="col-sm-9 col-9 px-0 my-auto">
                      <div
                        class="arrow_box mr-3"
                        [@flyOutans]="'in'"
                        *ngIf="isChecked && ansinSSncheck4"
                      >
                        <h1 class="questionMob">
                          You are moments away from ﬁnalizing your enrollment.
                          Thank you for using Honest Gorilla to shop for a new
                          energy plan. We appreciate you!
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div
                    class="pull-right col-sm-9 col-12 pr-0"
                    id="thankAns1"
                    *ngIf="isChecked && ansinSSncheck4 && timeTrue == true"
                  >
                    <label
                      class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow"
                      for="thankyou"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input mgntp10"
                        id="thankyou"
                        value="Thank you"
                        name="thankyou"
                        [(ngModel)]="servicedeniedList.value3"
                        (click)="onChangeRole($event)"
                      />
                      <label class="custom-control-label font20" for="thankyou"
                        >Thank you</label
                      >
                    </label>
                  </div>
                </div>
                <div
                  class="col-sm-9 col-9 ml-auto mt-1 px-0"
                  id="secondAns_id5"
                >
                  <div
                    class="col-12"
                    style="width: 100% !important; text-align: right"
                  >
                    <div
                      class="mb-3 ash_box text-right"
                      [@flyOutans]="'in'"
                      *ngIf="ansinSSncheck5"
                    >
                      <h1 class="ansMob text-right">{{ ansinSSncheck5 }}</h1>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
